// Module
var code = "<div class=\"accordion\"><ng-transclude></ng-transclude></div>";
// Exports
var _module_exports =code;;
var path = 'app/components/accordion/accordion.component.html';
var angular = require('angular');
angular.module('pims').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
export default path;